import { Button } from "@/components/ui/button";
import { Sparkles, ArrowRight } from "lucide-react";
import { useKopfaiClickTracking } from "@/hooks/useKopfaiClickTracking";

interface InlineCTAProps {
  variant?: "default" | "compact";
  postId?: number;
}

export function InlineCTA({ variant = "default", postId }: InlineCTAProps) {
  const { trackClick } = useKopfaiClickTracking();
  if (variant === "compact") {
    return (
      <div className="my-8 p-4 sm:p-6 bg-gradient-to-r from-kopf-primary/10 to-kopf-accent/10 border border-kopf-secondary rounded-lg">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <Sparkles className="w-5 h-5 sm:w-6 sm:h-6 text-kopf-accent shrink-0" />
            <p className="text-sm sm:text-base text-kopf-text font-medium">
              Experimente princípios da TCC com a KopfAI
            </p>
          </div>
          <Button asChild className="bg-kopf-primary hover:bg-kopf-primary/90 text-white w-full sm:w-auto">
            <a
              href="https://kopfai.com/ref/P4N9NKTN"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackClick("inline_cta_compact", postId)}
            >
              Começar agora
              <ArrowRight className="w-4 h-4 ml-2" />
            </a>
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="my-12 p-6 sm:p-8 bg-gradient-to-br from-kopf-primary to-kopf-accent rounded-2xl text-kopf-white shadow-lg">
      <div className="flex flex-col items-center text-center max-w-2xl mx-auto">
        <div className="bg-kopf-white/20 p-3 rounded-full mb-4">
          <Sparkles className="w-6 h-6 sm:w-8 sm:h-8" />
        </div>
        <h3 className="text-xl sm:text-2xl md:text-3xl font-bold mb-3">
          Transforme sua saúde mental conversando com a KopfAI
        </h3>
        <p className="text-kopf-white/90 text-base sm:text-lg mb-6">
          KopfAI é sua assistente pessoal de IA direcionada ao seu bem-estar mental. Utilize princípios da Terapia
          Cognitivo-Comportamental (TCC) para entender seus pensamentos e encontrar o equilíbrio.
        </p>
        <Button
          asChild
          size="lg"
          className="bg-kopf-white text-kopf-primary hover:bg-kopf-white/90 font-bold text-base sm:text-lg px-6 sm:px-8 w-full sm:w-auto"
        >
          <a
            href="https://kopfai.com/ref/P4N9NKTN"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackClick("inline_cta_default", postId)}
          >
            Conhecer a KopfAI
            <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 ml-2" />
          </a>
        </Button>
      </div>
    </div>
  );
}
